import { Card } from '@yleisradio/areena-types';

export function isValidRegionalChannelId(id: string, cardDeck: Card): boolean {
  if (!cardDeck.cards) return false;

  return cardDeck.cards.some((card): boolean => {
    const channelId = card.persistentState?.id;
    return !!channelId && channelId === id;
  });
}
